'use strict';

module.exports = class GuardedProcess {
	constructor(fns) {
		this._steps = fns || [];
		this._currentExec = null;
	}

	async _run(self, ...args) {
		let exec = (this._currentExec = darc.defer());

		try {
			let result;

			for (let i in this._steps) {
				let step = this._steps[i];

				if (typeof step !== 'function') {
					const CKError = require('../classes/Error');
					throw new CKError({
						message: 'Step is not a function',
						tags: {
							step: CK.fn.safeFormat(step)
						}
					});
				}

				result = step.call(self, ...args);

				if (result && result.then) {
					result = await result;
				}

				// Pass through return to next step
				args = [result];

				if (this._currentExec !== exec) {
					return this._currentExec || null;
				}
			}

			exec.fulfil(result);
		} catch (err) {
			exec.reject(err);
		}

		return exec;
	}

	async getOrStart(self, ...args) {
		if (!this._currentExec) {
			this._run(self, ...args);
		}

		return this._currentExec;
	}
	supersede(self, ...args) {
		let exec = this._currentExec;

		this.invalidate();

		this._run(self, ...args);

		if (exec) {
			exec.once(this._currentExec);
		}

		return this._currentExec;
	}
	overwrite(value) {
		let exec = this._currentExec;
		this.invalidate();

		this._currentExec = darc.defer(value);

		exec.once(this._currentExec);
	}
	invalidate() {
		delete this._currentExec;
	}
	destroy() {
		this.invalidate();
	}
	getExecution() {
		return this._currentExec;
	}
	isExecuting(exec) {
		if (exec) {
			return this.getExecution() === exec;
		} else {
			return !!this.getExecution();
		}
	}
};
